import { useState, useRef,useEffect } from 'react';
import { Col, Dropdown, Form, Nav } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTheme } from '../../Hooks';
import { buscar } from '../../Utils/Buscar';
import html2canvas from 'html2canvas';
import ToolTip from '../ToolTip/Tooltip';
import { Simplebar } from '../Simplebar/Simplebar';
import Skeleton from 'react-loading-skeleton';
import { InputSidebarContainer } from '../PantallasEdit/InputContainer/InputSideBarContainer';
import useMessage from '../../Hooks/useMessage';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import {ENVIAR_CORREO_REPORTAR_ERROR_URL} from "../../Utils";

const defaultReporteValue = {
    titulo: "",
    cc: "",
    descripcion: "",
    ss: null,
};

export const SupportButton = () => {
    const [showCanvas, setShowCanvas] = useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [showSkeleton, setShowSkeleton] = useState(true);
    const [reporte, setReporte] = useState(defaultReporteValue);

    const canvasRef = useRef();
    const { Message, cerrarAlertas, Warning } = useMessage();
    const { handleException } = useExceptionHandler();
    const { theme } = useTheme();

    useEffect(() => {
        if (!showCanvas) {
            setShowSkeleton(true);
            setReporte(defaultReporteValue);
        }
    }, [showCanvas]);

    const validar = () => {
        let isValid = true;
        if (reporte.titulo === "") {
            isValid = false;
            setValidationMsg("Debe proporcionar un título");
        } 
        else if(showSkeleton || !reporte.ss){
            isValid = false;
            Warning({messages: ["Espere un momento, la imagen aun esta cargando"]}); 
        }
        else setValidationMsg("");

        return isValid;
    };

    const enviarCorreo = () => {
        canvasRef.current?.showLoading(true);
        const _reporte = {
            Titulo: reporte.titulo,
            CorreoCopia: reporte.cc,
            Descripcion: reporte.descripcion,
            ScreenShot: reporte.ss,
        };
        buscar(ENVIAR_CORREO_REPORTAR_ERROR_URL, {reporte: _reporte}).then((data) => {
            if (data.Data.ok) {
                Message({ message: data.Data.msg });
                setTimeout(() => {
                    setShowCanvas(false);
                    setReporte(defaultReporteValue);
                    cerrarAlertas();
                }, 2000);
            }
        })
            .catch((e) => {
                handleException(e)
            })
            .finally(() => canvasRef.current?.showLoading(false))
    };

    const captureMainRoot = () => {
        return html2canvas(document.getElementById('MainRoot'), {logging: false});
    };

    const captureIframe = (iframe) => {
        return html2canvas(iframe.contentDocument.body, {logging: false});
    };
    
    const takeScreenshot = () => {
        captureMainRoot()
            .then((canvas) => {
                const iframe = document.getElementById('CitrusFRM');
                if (iframe) {
                    let messages = iframe.contentDocument.body.querySelector('.message');
                    if(messages){
                        messages.classList.remove('fadeIn')
                    }
                    return captureIframe(iframe).then((iframeCanvas) => {
                        const combinedCanvas = document.createElement('canvas');
                        const context = combinedCanvas.getContext('2d');

                        combinedCanvas.width = Math.max(canvas.width, iframeCanvas.width);
                        combinedCanvas.height = Math.max(canvas.height, iframeCanvas.height);

                        context.drawImage(canvas, 0, 0);
                        context.drawImage(iframeCanvas, Math.abs(canvas.width - iframeCanvas.width), 70);

                        return combinedCanvas;
                    });
                }
                return canvas;
            })
            .then((combinedCanvas) => {
                const container = document.querySelector("#canvas-container");
                container.innerHTML = null;
                const base64 = combinedCanvas.toDataURL();
                const image = new Image(500, 300);
                image.className = "border border-dark rounded";

                image.onload = () => {
                    container.append(image);
                    setShowSkeleton(false);
                    setReporte(prevReporte => ({
                        ...prevReporte,
                        ss: base64
                    }));

                }
                image.src = base64;
            })
            .catch((error) => {
                console.error("Error generating screenshot:", error);
            });
    };

    function reportarError(){
        cerrarAlertas();
        setShowCanvas(true);
        setTimeout(() => {
            takeScreenshot();
        }, 200);
    }

    useEffect(() => {
        if(window && !window.reportarError){
            window.reportarError = reportarError;
        }
    },[])
    return (
        <>
            <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                    as={Nav.Link}
                    id="dropdown-support"
                    className="buttonHover"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        reportarError(e)
                    }}
                >
                    <ToolTip placement="left" message="Incidencias">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            fill="#77777A"
                            height="34"
                            viewBox="0 -960 960 960"
                        >
                            <path d="M74.618-140.001 480-839.997l405.382 699.996H74.618Zm78.613-45.384h653.538L480-749.23 153.231-185.385Zm329.797-60.077q10.703 0 17.76-7.24 7.058-7.24 7.058-17.942t-7.24-17.76q-7.24-7.057-17.942-7.057t-17.76 7.239q-7.058 7.24-7.058 17.942 0 10.703 7.24 17.76 7.24 7.058 17.942 7.058Zm-22.874-97.922h45.384V-561.23h-45.384v217.846ZM480-467.307Z" />
                        </svg>
                    </ToolTip>
                </Dropdown.Toggle>
            </Dropdown>

            {createPortal(
                <Simplebar
                    ref={canvasRef}
                    size="lg"
                    useLoading={true}
                    backdrop={true}
                    placement={"end"}
                    portal={false}
                    visible={showCanvas}
                    setShow={(e) => {
                        setShowCanvas(e);
                        cerrarAlertas();
                    }}
                    title={"Reportar Incidente"}
                    btnLeft={{
                        show: true,
                        message: "Enviar",
                        isComponent: true,
                        size: "45px",
                        height: "24px",
                        with: "24px",
                        iconName: "send",
                        isCenter: true,
                        func: () => {
                            if (validar()) enviarCorreo();
                        },
                    }}
                    btnRight={{
                        show: false,
                        message: "Desestimar",
                        isComponent: false,
                        size: "45px",
                        height: "24px",
                        with: "24px",
                        iconName: "x-mark",
                        func: () => {
                            setShowCanvas(false);
                            setReporte(defaultReporteValue);
                            cerrarAlertas();
                        },
                    }}
                >
                    <>
                        <InputSidebarContainer label="Título">
                            <Form.Control
                                name="titulo"
                                type="text"
                                value={reporte.titulo}
                                onChange={(e) => {
                                    setReporte({
                                        ...reporte,
                                        titulo: e.target.value,
                                    });
                                }}
                            />
                            {validationMsg != "" && (
                                <Form.Text className="text-danger" id="validationMsg" muted>
                                    {validationMsg}
                                </Form.Text>
                            )}
                        </InputSidebarContainer>
                        <InputSidebarContainer label="Correo Copia">
                            <Form.Control
                                name="cc"
                                type="text"
                                value={reporte.cc}
                                onChange={(e) => {
                                    setReporte({
                                        ...reporte,
                                        cc: e.target.value,
                                    });
                                }}
                            />
                        </InputSidebarContainer>
                        <InputSidebarContainer label="Descripción">
                            <Form.Control
                                name="descripcion"
                                type="text"
                                as={"textarea"}
                                rows={3}
                                placeholder="Descripción"
                                value={reporte.descripcion}
                                onChange={(e) => {
                                    setReporte({
                                        ...reporte,
                                        descripcion: e.target.value,
                                    });
                                }}
                            />
                        </InputSidebarContainer>

                        <Col>
                            {showSkeleton && (
                                <div
                                    style={{ width: "100%", height: "300px" }}
                                    className="p-0 m-0"
                                >
                                    <Skeleton
                                        baseColor={theme.skeletonColor}
                                        style={{ zIndex: "0", height: "100%" }}
                                    />
                                </div>
                            )}
                            <div
                                id="canvas-container"
                                className={
                                    "text-center p-4" + (showSkeleton ? " d-none" : "")
                                }
                            ></div>
                        </Col>
                    </>
                </Simplebar>,
                document.querySelector("#sidebarContainer")
            )}
        </>
    );
};
